import dottie from 'dottie';

import { Serializable } from '../useStorage/index.ts';

// @ts-expect-error aglmd does not exist on window
const globals = (window?.aglmd ?? {}) as Record<string, Serializable>;

/**
 * Allows retrieving data that was injected into the page on serving the page
 *
 * @param key The key of the server preloaded application state
 * @param defaultValue The value to use if the key was not found or provided
 */
export default function getGlobalParam<T extends Serializable>(key: string, defaultValue?: T): T {
  if (Object.prototype.hasOwnProperty.call(globals, key)) {
    return Object.freeze(globals[key]) as T;
  }
  const value = dottie.get(globals, key, defaultValue) as T | undefined;

  if (value === undefined) {
    throw new Error(`missing required global: ${key}`);
  }

  return Object.freeze(value) as T;
}
